import logoPartArrow from '@/assets/brand/logo_part_arrow.png';
import logoPartBlue from '@/assets/brand/logo_part_blue.png';
import logoPartGreen from '@/assets/brand/logo_part_green.png';
import logoPartWarm from '@/assets/brand/logo_part_warm.png';
import { cn } from '@/lib/utils';
import { AppWordmark } from './AppWordmark';

const LOGO_PARTS = [
  {
    key: 'warm',
    src: logoPartWarm,
    delayClass: '[animation-delay:0ms]',
    originClass: 'origin-center',
  },
  {
    key: 'blue',
    src: logoPartBlue,
    delayClass: '[animation-delay:200ms]',
    originClass: 'origin-center',
  },
  {
    key: 'green',
    src: logoPartGreen,
    delayClass: '[animation-delay:400ms]',
    originClass: 'origin-center',
  },
  {
    key: 'arrow',
    src: logoPartArrow,
    delayClass: '[animation-delay:600ms]',
    originClass: 'origin-[47%_57%]',
  },
] as const;

export function BrandLoader() {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="flex animate-loader-appear flex-col items-center gap-4"
    >
      <span className="relative size-12">
        {LOGO_PARTS.map((part) => (
          <img
            key={part.key}
            src={part.src}
            alt=""
            className={cn(
              'absolute inset-0 size-full animate-loader-pop motion-reduce:animate-none',
              part.delayClass,
              part.originClass,
            )}
          />
        ))}
      </span>
      <AppWordmark hasLightSweep className="h-5" />
    </div>
  );
}
